import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Controlla che la stringa sia una partita IVA italiana valida.
     */
    vatNumber(errorMessage?: string): StringSchema;
  }
}

yup.addMethod(
  yup.string,
  'vatNumber',
  function (this: yup.StringSchema, errorMessage?: string) {
    return (
      this
        // https://it.wikipedia.org/wiki/Partita_IVA
        .test(
          'vatNumber',
          errorMessage ?? 'La Partita IVA non è valida',
          value => {
            console.log('value', value);
            if (!value) return true;
            // Se la stringa è vuota, il test non deve fallire.
            // In questo modo permettiamo la validità di campi opzionali "cancellati" a mano dall'utente.
            // Sarà poi la validazione del campo obbligatorio a gestire il caso.
            if (value === '') return true;

            const regexTest = /^[0-9]{11}$/.test(value);
            if (!regexTest) return false;

            if (value.length !== 11) return false;

            const values = value.split('').map(Number);

            // Somma delle posizioni dispari + il doppio delle posizioni pari
            // Riduciamo di 9 i valori maggiori di 9
            const sum = values.reduce((acc, digit, index) => {
              const d = index % 2 === 0 ? digit : digit * 2;
              return acc + (d > 9 ? d - 9 : d);
            }, 0);

            // Se il modulo 10 della somma è 0, la partita IVA è valida
            return sum % 10 === 0;
          },
        )
    );
  },
);
